<template>
  
        
  <div class="column" style="position: relative; background-color: var(--back);background-position: center;background-repeat: no-repeat;background-size: cover;" :style="{width, height, borderRadius: r, backgroundImage:`url(${src})`}">
        
    </div>          

    
</template>
<script>

/*

    <back :src="image" width="150px" height="150px" r="20px"/>
 
*/

export default {
    data: function () {return {
        previewPopup: false,        
        res: {}
    }},
    props:{
        modelValue: Boolean,        
        width:{type:String, default:'150px'},
        height:{type:String, default:'150px'},
        r:{type:String, default:'15px'},
        src: String,                  
    },
    
    mounted() {
        // await this.size()
    },

    computed: {
        // sizetitle(){            
        //     if (!this.src) return ''            
        //     return `${this.res.width} × ${this.res.height}`
        // },
    },
    
    methods: {
        // async size(){
        //     this.res = await this.tools.imageSize(this.src)
        // },

        // remove(){
        //     this.$emit('close', true);
        // }
    },
}
</script>

<style scoped>

</style>

